export type PricingFeatureIconName =
  'doc' | 'sparkle' | 'chat' | 'check' | 'lab';

// 노드의 시각 정보(아이콘)만 보유한다. 라벨 등 표시 텍스트는 다국어 메시지에서 해석한다.
type PricingFeature = {
  icon: PricingFeatureIconName;
};

export type PricingPlanId =
  'free' | 'standard' | 'pro' | 'pro-plus' | 'enterprise';

// 표시 텍스트(heading/credits/buttonLabel/feature label)는 pricing 네임스페이스에서
// plan.id 로 해석한다. 여기에는 로케일 불변 데이터만 남긴다.
// - eyebrow: 브랜드 명이자 JSON-LD Offer name (page.tsx 가 소비)
// - price/priceSuffix: 표기 + getPlanPriceKRW 가 파싱하는 원본 (page.tsx 가 소비)
// - badge: 'Most popular' (로케일 불변)
// - features: 아이콘 순서. 라벨은 같은 인덱스의 메시지 배열에서 매칭.
export type PricingPlan = {
  id: PricingPlanId;
  eyebrow: string;
  price?: string;
  priceSuffix?: string;
  badge?: string;
  features: PricingFeature[];
};

export const PRICING_PLANS: PricingPlan[] = [
  {
    id: 'free',
    eyebrow: 'Free',
    features: [{ icon: 'doc' }, { icon: 'sparkle' }, { icon: 'chat' }],
  },
  {
    id: 'standard',
    eyebrow: 'Standard',
    price: '₩ 22,000',
    priceSuffix: '/ month',
    features: [
      { icon: 'doc' },
      { icon: 'sparkle' },
      { icon: 'chat' },
      { icon: 'check' },
      { icon: 'lab' },
    ],
  },
  {
    id: 'pro',
    eyebrow: 'Pro',
    price: '₩ 55,000',
    priceSuffix: '/ month',
    badge: 'Most popular',
    features: [
      { icon: 'doc' },
      { icon: 'sparkle' },
      { icon: 'chat' },
      { icon: 'check' },
      { icon: 'lab' },
    ],
  },
  {
    id: 'pro-plus',
    eyebrow: 'Pro Plus',
    price: '₩110,000',
    priceSuffix: '/ month',
    features: [
      { icon: 'doc' },
      { icon: 'sparkle' },
      { icon: 'chat' },
      { icon: 'check' },
      { icon: 'lab' },
    ],
  },
  {
    id: 'enterprise',
    eyebrow: 'Enterprise',
    features: [{ icon: 'check' }],
  },
];

// 'free' 는 price 필드가 없지만 0원이며, 'enterprise' 는 문의형이라 금액이 없다(null).
// '₩ 22,000' / '₩110,000' 처럼 표기가 들쭉날쭉해 숫자만 추출한다.
export function getPlanPriceKRW(plan: PricingPlan): number | null {
  if (plan.id === 'free') return 0;
  if (plan.price === undefined) return null;

  const digits = plan.price.replace(/[^\d]/g, '');
  return digits ? Number(digits) : null;
}
